import ChatRequestList from '@/controllers/chat/request-list.js';

export default {
  extends: ChatRequestList,
}
